import { Tab } from '../types/tabTypes';

export function filterTabsByStatus(tabs: Tab[], status: string): Tab[] {
    if (status === 'all') {
        return tabs;
    }

    return tabs.filter((tab) =>
        status === 'active' ? tab.active : !tab.active,
    );
}
